var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3406,
    height: 2369,
    viewBox: "0 0 3406 2369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "3_52",
    d: "M1142.79 1250.95L1412.42 1078.84L1547.62 1288.58L1255.35 1475.79L1203.54 1393.1L1225.33 1379.63L1142.79 1250.95Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "3_36",
    d: "M2765.35 1255.34L2765.97 1024.12H3147.28V1255.34H2765.35Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "3_35",
    d: "M2765.81 1024.19L2764.2 783.186H3147.19V1024.19H2765.81Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "3_34",
    d: "M2628.69 1030.19V1125.19H2348.19V782.186H2763.57V905.686H2686.19H2685.19V906.686V1029.19H2629.69H2628.69V1030.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "3_37",
    d: "M2765.34 1255.35H3147.25V1488.17H2765.34V1255.35Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "3_33",
    d: "M2368.19 1566.19H2624.19V2021.19H2368.19V1566.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "3_40",
    d: "M2141.19 1699.19H2368.19V2021.19H2141.19V1699.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "3_41",
    d: "M1912.19 1699.19H2141.19V2021.19H1912.19V1699.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "3_31",
    d: "M1912.19 1316.19H2141.19V1638.19H1912.19V1316.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "3_30",
    d: "M1659.19 1560.19H1634.19V1316.19H1912.19V1638.19H1660.19V1561.19V1560.19H1659.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "3_42",
    d: "M1673.19 1699.19H1912.19V2021.19H1673.19V1699.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "3_45",
    d: "M1203.38 1525.6L1336.71 1730.91L1098.39 1885.68L965.061 1680.37L1203.38 1525.6Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "3_46",
    d: "M1174.94 1411.09L1175.47 1411.89L1176.29 1411.39L1204.03 1394.45L1255.42 1475.71L958.744 1670.4L825.553 1465.3L1093.57 1289.63L1174.94 1411.09Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "3_47",
    d: "M1043.12 1212.91L1043.68 1213.74L1044.51 1213.19L1068.22 1197.28L1118.65 1270.99L823.021 1464.74L701.024 1276.88L968.446 1101.74L1043.12 1212.91Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "3_51",
    d: "M899.543 876.758L1166.9 699.579L1294.31 897.884L1025.99 1069.81L899.543 876.758Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "3_50",
    d: "M772.568 678.479L1039.56 503.575L1166.98 701.888L898.991 875.301L772.568 678.479Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "3_48",
    d: "M520.342 998.405L788.444 822.122L969.805 1100.89L700.485 1275.8L520.342 998.405Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "3_49",
    d: "M772.853 679.731L791.792 708.868L733.673 744.329L732.791 744.867L733.358 745.731L784.312 823.399L520.481 998.29L314.654 681.63L517.24 549.519L518.076 548.974L517.533 548.137L494.078 511.98L680.887 391.569L701.849 424.717L702.386 425.567L703.233 425.025L904.045 296.382L1039.31 503.398L773.142 678.35L772.311 678.896L772.853 679.731Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "3_43",
    d: "M1439.19 1699.19H1673.19V2007.19H1439.19V1699.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "3_44",
    d: "M1375.55 1699.19H1439.19V1971.19H1212.96L1141.55 1857.47L1375.55 1699.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "3_32",
    d: "M2368.19 1566.29V1638.19H2141.19V1316.19H2375.25V1371.38V1372.38H2376.25H2624.19V1565.29H2369.19H2368.19V1566.29Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "3_38",
    d: "M2861.19 1620.19H2765.19V1488.19H3147.19V1720.19H2862.19L2862.19 1621.19V1620.19H2861.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "3_39",
    d: "M2868.19 1971.19V2021.19H2624.69V1621.69H2861.19V1719.19V1720.19H2862.19H3147.19V1970.19H2869.19H2868.19V1971.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor3);
export default __webpack_public_path__ + "static/media/select_floor_3.0e484d7398a28637a5d3af50fb6e8b7a.svg";
export { ForwardRef as ReactComponent };